import {Action} from '@ngrx/store';

export const GET_ALL_FREELANCERS = '[Freelancers] Get All';
export const GET_FREELANCER = '[Freelancers] Get Freelancer';
export const GET_ALL_FREELANCERS_SUCCESS = '[Freelancers] Get All Success';
export const GET_ALL_FREELANCERS_ERROR = '[Freelancers] Get All Error';
export const GET_FREELANCER_SUCCESS = '[Freelancers] Get Freelancer Success';
export const GET_FREELANCER_ERROR = '[Freelancers] Get Freelancer Error';

export const ADD_FREELANCER = '[Freelancer] Add';
export const ADD_FREELANCER_SUCCESS = '[Freelancer] Add Success';
export const ADD_FREELANCER_ERROR = '[Freelancer] Add Error';

export const UPDATE_FREELANCER = '[Freelancer] Update';
export const UPDATE_FREELANCER_SUCCESS = '[Freelancer] Update Success';
export const UPDATE_FREELANCER_ERROR = '[Freelancer] Update Error';

export const DELETE_FREELANCER = '[Freelancer] Delete';
export const DELETE_FREELANCER_SUCCESS = '[Freelancer] Delete Success';
export const DELETE_FREELANCER_ERROR = '[Freelancer] Delete Error';


export class GetAllFreelancers implements Action {
  readonly type = GET_ALL_FREELANCERS;
}

export class GetAllFreelancersSuccess implements Action {
  readonly type = GET_ALL_FREELANCERS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetAllFreelancersError implements Action {
  readonly type = GET_ALL_FREELANCERS_ERROR;

  constructor(public payload: any) {
  }
}

export class GetFreelancer implements Action {
  readonly type = GET_FREELANCER;

  constructor(public payload: any) {
  }
}

export class GetFreelancerSuccess implements Action {
  readonly type = GET_FREELANCER_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetFreelancerError implements Action {
  readonly type = GET_FREELANCER_ERROR;

  constructor(public payload: any) {
  }
}

export class AddFreelancer implements Action {
  readonly type = ADD_FREELANCER;

  constructor(public payload: any) {
  }
}

export class AddFreelancerSuccess implements Action {
  readonly type = ADD_FREELANCER_SUCCESS;

  constructor(public payload: any) {
  }
}

export class AddFreelancerError implements Action {
  readonly type = ADD_FREELANCER_ERROR;

  constructor(public payload: any) {
  }
}

export class UpdateFreelancer implements Action {
  readonly type = UPDATE_FREELANCER;

  constructor(public payload: any) {
  }
}

export class UpdateFreelancerSuccess implements Action {
  readonly type = UPDATE_FREELANCER_SUCCESS;

  constructor(public payload: any) {
  }
}


export class UpdateFreelancerError implements Action {
  readonly type = UPDATE_FREELANCER_ERROR;

  constructor(public payload: any) {
  }
}

export class DeleteFreelancer implements Action {
  readonly type = DELETE_FREELANCER;

  constructor(public payload: any) {
  }
}

export class DeleteFreelancerSuccess implements Action {
  readonly type = DELETE_FREELANCER_SUCCESS;

  constructor(public payload: any) {
  }
}


export class DeleteFreelancerError implements Action {
  readonly type = DELETE_FREELANCER_ERROR;

  constructor(public payload: any) {
  }
}


export type FreelancerAction =
  GetAllFreelancers
  | GetAllFreelancersSuccess
  | GetAllFreelancersError
  | GetFreelancer
  | GetFreelancerError
  | GetFreelancerSuccess
  | AddFreelancer
  | AddFreelancerSuccess
  | AddFreelancerError
  | UpdateFreelancer
  | UpdateFreelancerSuccess
  | UpdateFreelancerError
  | DeleteFreelancer
  | DeleteFreelancerSuccess
  | DeleteFreelancerError;



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/freelancers/store/actions/freelancer.action.ts